import Registry from "./models/Registry";
import './components/MainMenu';
import './components/Fadein.js';
import './components/SmoothAnchor.js';

import GMap from './components/GMap.js';

class App {
  constructor(context) {
    this.registry = new Registry();
    this.registerComponents(); 
    this.initController(context);
    this.patchIos();
    this.setvh();
  }

  initController(contextData) {
    const ContextClass = this.registry.getContext(contextData);
    new ContextClass(contextData);
  }

  registerComponents() {
    this.registry
      // ---- Componenti Caricati Staticamente ----
      // Registriamo direttamente la classe importata


      // ---- Componenti Caricati Dinamicamente ----
      // Registriamo una FUNZIONE che esegue l'import dinamico
      .addComponent('SliderLoghi', () => import("./components/SliderLoghi.js"))
      .addComponent('SliderHero', () => import("./components/SliderHero.js"))
      .addComponent('ProductsSlider', () => import("./components/ProductsSlider.js"))
      .addComponent('SliderText', () => import("./components/SliderText.js"))
      .addComponent('FiltroProdottiModa', () => import("./components/FiltroProdottiModa.js"))
      .addComponent('SliderCategories', () => import("./components/SliderCategories.js"))
      .addComponent('StickyColumn', () => import("./components/StickyColumn.js"))
      .addComponent('CambioBg', () => import("./components/CambioBg.js"))
			.addComponent('FiltriAperture', () => import("./components/FiltroAperture.js"))
			.addComponent('LavoraConNoiTabs', () => import("./components/lavora-con-noi.js"))
      .addComponent('AttachedFile', () => import("./components/AttachedFile.js"))
      .addComponent('SpotVideoPlayer', () => import("./components/SpotVideoPlayer.js"))
      .addComponent('ImageWrapper', () => import("./components/ImageWrapper.js"))
      .addComponent('SnowFalling', () => import("./components/SnowFalling.js"))
      .addComponent('SelectionIntroReveal', () => import("./components/SelectionIntroReveal.js"))
      .addComponent('SelectionInlineBadges', () => import("./components/SelectionInlineBadges.js"))
      .addComponent('SelectionParallax', () => import("./components/SelectionParallax.js"))
      .addComponent('SelectionLines', () => import("./components/SelectionLines.js"))
    ;
    
  }

  patchIos() {
    window.addEventListener('resize', () => this.appHeight());
    this.appHeight();
  }

  appHeight() {
    const doc = document.documentElement;
    doc.style.setProperty('--app-height', `${window.innerHeight}px`);
  }

  setvh() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

}

window.AppInit = function(context) {
    new App(context);
};
